import CopyToClipboardButton from "./CopyToClipboardButton";

export default CopyToClipboardButton;
